module.exports = __webpack_public_path__ + "images/bfbba89.png";